// Copyright (c) 2018 Deere & Company

import actions from '../../../../sharedmodules/actions-list';
import { getDefaultState } from '../state';

const updateModalVisibility = (state, action) => action.isVisible;

export default (state = getDefaultState().isAmountOfUseModalOpen, action) => {

    const actionTypes = {
        [actions.UPDATE_NEW_TRANSFER_AMOUNT_OF_USE_MODAL_VISIBILITY]: updateModalVisibility,
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};
